import { DeleteOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { Dropdown, Space, Table } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { formatDateTime } from "utils/formatter";
import TableAntd from "components/elements/Table/Table";
function formatDate({ dateString, pattern = "YYYY-MM-DD", reFormat = "DD-MM-YYYY" }) {
  if (!dateString) return;
  const date = dayjs(dateString, pattern);
  return date.format(reFormat);
}
const EmployeeEmploymentMovementTable = ({
  isLoading = true,
  pagination = {},
  getWorkflow = () => { },
  movementList = [],
  onRowDelete = () => { },
  onChange = () => { },
  onRowClick = () => { },
}) => {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  // console.log(record.createDate)
  const columns = [
    // {
    //   title: <div className="text-table">{t('employment.label.doc_no')}</div>,
    //   dataIndex: "seq",
    //   key: "seq",
    //   align: "center",
    //   width: 130,
    //   render: (_, record) => {
    //     return <div onClick={() => onRowClick(record, "modifiedBy")}>{record.seq}</div>
    //   }
    // },
    // {
    //   title: <div className="text-table">{t('employment.label.movement_type')}</div>,
    //   dataIndex: "movementType",
    //   key: "movementType",
    //   width: 200,
    //   render: (_, record) => {
    //     return <div onClick={() => onRowClick(record, "modifiedBy")}>{i18n.language === "en" ? record?.movementTypeNameEN : record?.movementTypeName}</div>
    //   }
    // },
    // {
    //   title: <div className="text-table">{t('employment.label.movement_type_group')}</div>,
    //   dataIndex: "movementTypeGroup",
    //   key: "movementTypeGroup",
    //   width: 200,
    //   render: (_, record) => {
    //     return <div onClick={() => onRowClick(record, "modifiedBy")}>{i18n.language === "en" ? record?.movementTopicNameEn : record?.movementTopicName}</div>
    //   }
    // },
    // {
    //   title: <div className="text-table">{t('employment.label.effective_date')}</div>,
    //   dataIndex: "effectiveDate",
    //   key: "effectiveDate",
    //   width: 140,
    //   render: (_, record) => {
    //     return <div onClick={() => onRowClick(record, "modifiedBy")}>{formatDate({ dateString: record?.effectiveDate, reFormat: i18n.language === "en" ? "DD MMM YYYY" : "DD MMMM BBBB" })}</div>
    //   }
    // },
    {
      title: <div className="text-table">{t('employment.label.doc_no')}</div>,
      dataIndex: "_id",
      key: "_id",
      width: 200,
      render: (_, record) => {
        return <div>{record?._id}</div>
      }
    },

    {
      title: <div className="text-table">{t('employment.label.movement_type')}</div>,
      dataIndex: "movementTypeName",
      key: "movementTypeName",
      width: 200,
      render: (_, record) => {
        return <div>{i18n.language === 'en' ? record?.movementTypeNameEn : record?.movementTypeName}</div>
      }
    },
    {
      title: <div className="text-table">{t('document.create_date')}</div>,
      dataIndex: "createDate",
      key: "createDate",
      width: 150,
      render: (_, record) => {
        return (

          <div>{
            formatDate({ dateString: record?.createDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" })}
          </div>)
      }
    },
    {
      title: <div className="text-table">{t('employment.label.effective_date')}</div>,
      dataIndex: "effectiveDate",
      key: "effectiveDate",
      width: 150,
      render: (_, record) => {
        return <div>{formatDate({ dateString: record?.effectiveDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" })}</div>
      }
    },
    {
      title: <div className="text-table">{t('document.approved_date')}</div>,
      dataIndex: "createDate",
      key: "createDate",
      width: 150,
      render: (_, record) => {
        return (
          <div>{record?.approveDate ? formatDate({ dateString: record?.approveDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" }) : "-"}</div>

        )
      }
    },
    // {
    //   title: <div className="text-table">{t('employment.label.movement_type_group')}</div>,
    //   dataIndex: "createDate",
    //   key: "createDate",
    //   width: 200,
    //   render: (_, record) => {
    //     return <div>{formatDate({ dateString: record?.createDate, reFormat: i18n.language === "en" ? "DD MMM YYYY" : "DD MMMM BBBB" })}</div>
    //   }
    // },


    {
      title: <div className="text-table">{t("employee.label.status")}</div>,
      dataIndex: "employeeStatus",
      key: "employeeStatus",
      sorter: true,
      width: 160,
      align: "center",
      render: (_, record) => {
        console.log("con", record?.approveStatusEn)
        // let language = i18n.language === 'en' ? "En" : ""
        // console.log(language)
        // console.log(record?.movementDetails)
        // console.log(i18n.language === 'en')
        return (
          i18n.language === 'en' ?
            record?.approveStatus ?
              <StatusTag
                value={record?.approveStatusEn}
                text={(record?.approveStatusEn)} /> : "-" :
            record?.approveStatus ?

              <StatusTag
                value={record?.approveStatus}
                text={(record?.approveStatus)} /> : "-"


        )
      },
    },

    {
      title: <div className="text-table">{t('employment.label.last_modified')}</div>,
      dataIndex: "lastModified",
      width: 170,
      key: "lastModified",
      render: (_, record) => {
        const namesupTH = `${record?.movementDetails?.approveBy?.name} ${record?.movementDetails?.approveBy?.surName}`;
        const namesupEN = `${record?.movementDetails?.approveBy?.nameEn} ${record?.movementDetails?.approveBy?.surNameEn}`;
        const nameTH = `${record.createBy.name} ${record.createBy.surName}`;
        const nameEN = `${record.createBy.nameEn} ${record.createBy.surNameEn}`;
        const name =
          i18n.language === "en" && nameEN
            ? nameEN
            : nameTH;
        const namesup =
          i18n.language === "en" && namesupEN
            ? namesupEN
            : namesupTH;
        return (
          record?.movementDetails?.approveBy ?
            <>
              {namesup}
              <br />
              {record?.movementDetails?.updateDate ? formatDateTime(record?.movementDetails?.updateDate) : "-"}
            </>
            :
            <>

              {name}
              <br />
              {record.createDate ? formatDateTime(record.createDate) : "-"}


            </>
        );
      },
    },
    roles.includes("DELETE_EMPLOYEE|EMPLOYMENT|MOVEMENT") ? {
      title: "",
      key: "action",
      width: 60,
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                {
                  key: "1",
                  onClick: () => {
                    console.log("record", record)
                    onRowClick(record);
                    getWorkflow({ flowRequestId: record?.id });
                  },
                  label: `${t("action.view")}`,
                  icon: (
                    <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                // {
                //   key: "2",
                //   label: (
                //     <p
                //       style={{ color: "grey", fontSize: "14px" }}
                //       onClick={() => onEdit(record?.id)}
                //     >
                //       {t("action.edit")}
                //     </p>
                //   ),
                //   icon: (
                //     <EditOutlined
                //       style={{ fontSize: "18px", color: "gray" }}
                //       onClick={() => onEdit(record?.id)}
                //     />
                //   ),
                // },
                // {
                //   key: "3",
                //   label: (
                //     // eslint-disable-next-line jsx-a11y/anchor-is-valid
                //     <a
                //       href="#"
                //       onClick={(e) => {
                //         e.preventDefault();
                //         onRowDelete(record?.id);
                //       }}
                //       style={{ color: "grey", fontSize: "14px" }}
                //     >
                //       {t("action.delete")}
                //     </a>
                //   ),
                //   icon: (
                //     <DeleteOutlined
                //       style={{ fontSize: "18px", color: "gray" }}
                //     />
                //   ),
                // },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    } : {},
  ];

  return (
    <TableAntd
      loading={isLoading}
      // pagination={{
      //   ...pagination,
      //   showTotal: (total, range) =>
      //     t("paginate.description")
      //       .replace("{min}", range[0])
      //       .replace("{max}", range[1])
      //       .replace("{total}", total),
      // }}
      pagination={false}
      dataSource={movementList}
      rowKey={(record) => record.id}
      columns={columns}
      onChange={onChange}
      tableLayout="fixed"
      scroll={{ x: 1000 }}
    />
  );
};

export default EmployeeEmploymentMovementTable;
